<template>
  <div v-if="!selecionouMva">
    <div class="mva-container" v-for="registro in dados">
      <RadioButton :classe="classe" :imposto="registro" :seleciona="seleciona" />
      <Registro>
        <Cabecalho
          nowrap
          :tipo="filtroTipo(registro.mvaOriginal)"
          :titulo="titulo(registro)"
          :aliquota="aliquota(registro)"
        />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="mva-container">
      <EditButton v-if="dados.length > 1" :classe="classe" :edita="edita" />

      <Registro>
        <Cabecalho
          nowrap
          :tipo="filtroTipo(mvaSelecionado.mvaOriginal)"
          :titulo="titulo(mvaSelecionado)"
          :aliquota="aliquota(mvaSelecionado)"
        />
      </Registro>
    </div>
  </div>
</template>

<script>
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import EditButton from "@/components/Button/EditButton.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
export default {
  name: "RegistrosMva",

  props: {
    dados: Object | Array,
    classe: String,
    tipo: String,
    seleciona: Function,
    edita: Function,
    mvaSelecionado: Object | Array,
    selecionouMva: Boolean
  },

  components: {
    Cabecalho,
    EditButton,
    RadioButton,
    Registro
  },

  created() {
    if (this.dados && this.dados.length == 1) {
      this.seleciona(this.dados[0]);
    }
  },

  updated() {
    if (this.dados.length == 1) {
      this.seleciona(this.dados[0]);
    }
  },

  watch: {
    selecionouMva() {
      this.$emit("selecionouMva", this.selecionouMva);
    }
  },

  computed: {},

  methods: {
    filtroTipo: function(mva) {
      return mva ? (mva.indexOf("href") > -1 ? "link" : "") : null;
    },
    titulo(dado) {
      switch (this.classe) {
        case "icms_st":
          return dado.base_de_calculo_st;
        case "antecipacao":
          return dado.base_calculo_antecipacao;
        default:
          break;
      }
    },
    aliquota(dado) {
      switch (this.classe) {
        case "icms_st":
          return dado.valor;
        case "antecipacao":
          return dado.mva;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mva-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  .mva-container-carga-liquida {
    display: flex;
    flex-direction: column;
  }
}
</style>
